module.exports = __webpack_public_path__ + "img/menu9.283e5f56.png";